import * as React from "react";
import { cn } from "@/lib/utils";

interface TextareaProps
   extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
   variant?: "light" | "dark";
   error?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
   (
      { variant = "light", error, className, value, placeholder, ...props },
      ref
   ) => {
      const isFilled = typeof value === "string" && value.length > 0;

      const base =
         "w-full rounded-[18px] border px-6 py-3 text-fs-m-body-m-line transition-colors outline-none resize-none";

      const styles = {
         light: {
            text: "text-custom-dark placeholder:text-custom-dark/70",
            borderEmpty: "border-custom-dark/20",
            borderFilled: "border-custom-dark",
            borderError: "border-red-500",
            hoverBorder: "hover:border-custom-dark",
         },
         dark: {
            text: "text-white placeholder:text-white/70 bg-custom-dark",
            borderEmpty: "border-white/20",
            borderFilled: "border-white/60",
            borderError: "border-red-500",
            hoverBorder: "hover:border-white/60",
         },
      }[variant];

      const borderColor = error
         ? styles.borderError
         : isFilled
           ? styles.borderFilled
           : styles.borderEmpty;

      const interactive =
         !error && `${styles.hoverBorder} focus:${styles.hoverBorder}`;

      return (
         <textarea
            {...props}
            value={value}
            placeholder={placeholder}
            ref={ref}
            className={cn(
               base,
               styles.text,
               borderColor,
               interactive,
               className
            )}
         />
      );
   }
);

Textarea.displayName = "Textarea";
